import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'

class Box extends PureComponent {
  render () {
    const innerBoxStyle = {}
    if (this.props.innerBoxCentered) {
      innerBoxStyle.marginRight = 'auto'
      innerBoxStyle.marginLeft = 'auto'
    }
    if (this.props.backgroundColor) {
      innerBoxStyle.backgroundColor = this.props.backgroundColor
    }
    return (
      <div className="box" style={this.props.style}>
        <div style={innerBoxStyle} className="boxInner">{this.props.children}</div>
      </div>
    )
  }
}

Box.propTypes = {
  style: PropTypes.object,
  innerBoxCentered: PropTypes.bool,
  backgroundColor: PropTypes.string
}
export default Box
